// Subject accent mapping per design guidelines (Teal=Bio, Sapphire=Chem, Violet=Physics)
export function subjectAccent(subject = "") {
  const s = subject.toLowerCase();
  if (s.includes("bio")) return { key: "biology", text: "text-teal-700", bg: "bg-teal-50", border: "border-teal-200", dot: "bg-teal-600", ring: "ring-teal-600" };
  if (s.includes("chem")) return { key: "chemistry", text: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200", dot: "bg-blue-600", ring: "ring-blue-600" };
  if (s.includes("phys")) return { key: "physics", text: "text-violet-700", bg: "bg-violet-50", border: "border-violet-200", dot: "bg-violet-600", ring: "ring-violet-600" };
  return { key: "general", text: "text-slate-700", bg: "bg-slate-100", border: "border-slate-200", dot: "bg-slate-500", ring: "ring-slate-500" };
}

export function SubjectPill({ subject, children, className = "" }) {
  const a = subjectAccent(subject);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium font-mono uppercase tracking-wide ${a.bg} ${a.text} ${a.border} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${a.dot}`} />
      {children || subject}
    </span>
  );
}
